module.exports = __webpack_public_path__ + "38b8ed4bea691d4c482d028ae684e605.pdf";